export const OTHER_ROUTES = {
  FINANCE: "/finance",
  HRM: "/hrm",
  PLATFORM_ANALYTICS: "/analytics",
  PLATFORM_MONITORING: "/monitoring",
  USER_ACCOUNT_SETTINGS: "/settings/me/profile",
  USER_ACCOUNT_SETTINGS_AI_DEFAULTS: "/settings/me/ai-defaults",
  USER_ACCOUNT_SETTINGS_MAIL: "/settings/me/mail",
  USER_ACCOUNT_SETTINGS_ZALO: "/settings/me/zalo",
  USER_ACCOUNT_SETTINGS_PROFILE: "/settings/me/profile",
  USER_ACCOUNT_SETTINGS_PASSWORD: "/settings/me/password",
  USER_ACCOUNT_SETTINGS_MAIL_OAUTH_CLOSE: "/settings/me/mail/oauth-close",
  DATA_GOVERNANCE: "/data-governance",
  DATA_GOVERNANCE_CATALOG: "/data-governance/catalog",
  DATA_GOVERNANCE_POLICY: "/data-governance/policy",
  DATA_GOVERNANCE_DRIFT: "/data-governance/drift",
  DATA_GOVERNANCE_PROJECTION: "/data-governance/projection",
} as const;

export type OtherRouteKey = keyof typeof OTHER_ROUTES;
